import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isSelected", "isHighlighted", "readOnly", "disabledDescription", "isDisabled", "onEditAction", "getNextAction", "width", "height", "TitleAction", "getHeaderTitle", "borderStyle", "overrideAccentColor"];
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import { GO_TO } from 'automation-ui-action-features/actions/ActionMetadataConfigs';
import GoToActionSummary from 'automation-ui-action-features/actions/go-to/GoToActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
const GoToActionCard = _ref => {
  let {
      isSelected = false,
      isHighlighted,
      readOnly = false,
      disabledDescription,
      isDisabled,
      onEditAction,
      getNextAction,
      width,
      height,
      TitleAction,
      getHeaderTitle,
      borderStyle,
      overrideAccentColor
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    icon,
    theme
  } = GO_TO;
  const nextAction = getNextAction();
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    content: /*#__PURE__*/_jsx(GoToActionSummary, {
      nextAction: nextAction,
      getActionLabelById: getHeaderTitle
    }),
    isDisabled: isDisabled,
    disabledDescription: disabledDescription,
    isSelected: isSelected,
    isHighlighted: isHighlighted,
    headerIcon: icon,
    titleUseTheme: theme,
    headerTitle: GO_TO.getActionLabel(),
    width: width,
    height: height,
    TitleAction: TitleAction,
    onClick: onEditAction,
    clickable: !readOnly,
    borderStyle: borderStyle,
    overrideAccentColor: overrideAccentColor
  }));
};
export default GoToActionCard;